import axios from "@/request";
import qs from "qs";

export default {
  async getUsers(params: any) {
    return axios.get("user/list", { params});
  },
  async detail(params: any) {
    return axios.get("user/detail", { params });
  },
  async playbill(params: any) {
    return axios.get("user/playbill", { params });
  },
  async orderbill(params: any) {
    return axios.get("user/orderbill", { params });
  },
  async otherbill(params: any) {
    return axios.get("user/otherbill", { params });
  },
  async memberpics(params: any) {
    return axios.get("uploadpicmember/list", { params });
  },
  async services(params: any) {
    return axios.get("user/services/list", { params });
  },
  async servicedetail(params: any) {
    return axios.get("user/services/detail", { params });
  },
  async credits(params: any) {
    return axios.get("credits/list", { params });
  },
  async overview(params: any) {
    return axios.get("user/overview", { params });
  },
  async player(params: any) {
    return axios.get("user/player", { params });
  },
  async aiPlayer(params: any) {
    return axios.get("user/ai-player", { params });
  },
  async aiPlayerLog(params: any) {
    return axios.get("user/ai-player-log", { params });
  },
  async contact(params: any) {
    return axios.get("user/contact", { params });
  },
  async makeAGroup(params: any) {
    return axios.post("user/make-a-group", qs.stringify(params));
  },
  async activities(params: any) {
    return axios.get("user/activities", { params });
  },
  async vipcard(params: any) {
    return axios.get("user/vip-card", { params });
  },
  async vipcardexport(params: any) {
    return axios.get("user/vip-card-export", { params, responseType: "blob" });
  },
  async vipcarddetail(params: any) {
    return axios.get("user/vip-card-detail", { params });
  },
  async cancelVipCard(params: any) {
    return axios.post("user/cancel-vip-card", qs.stringify(params));
  },
  async testbuy(params: any) {
    return axios.post("user/test-buy", qs.stringify(params));
  },
  async editvipcard(params: any) {
    return axios.post("user/edit-vip-card", qs.stringify(params));
  },
  async frozenmoney(params: any) {
    return axios.post("user/frozen-money", qs.stringify(params));
  },
  async addRequest(params: any) {
    return axios.get("user/add-request", { params });
  },
  async addRequestData(params: any) {
    return axios.get("user/add-request-data", { params });
  },
  async setIsMaster(params: any) {
    return axios.post("user/set-is-master", qs.stringify(params));
  },
  async balanceTotal(params: any) {
    return axios.get("user/balance-total", { params });
  },
  async coupon(params: any) {
    return axios.get("user/coupon", { params });
  },
  async deposit(params: any) {
    return axios.get("user/deposit", { params });
  },
  async depositCategory(params: any) {
    return axios.get("user/deposit-category", { params });
  },
  async saveDepositFrozenTime(params: any) {
    return axios.post("user/save-deposit-frozen-time", qs.stringify(params));
  },
  async setIsNoSms(params: any) {
    return axios.post("user/set-is-nosms", qs.stringify(params));
  }
};
